import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import click from '@mailobj-browser/front/js/events/types/click.js'

const onClick = object(listener, {
  type: click,
  passive,
  task: async target => {
    const { value } = target

    if (value === 'on') {
      target.setAttribute('aria-checked', 'false')
      target.value = 'off'
    } else {
      target.setAttribute('aria-checked', 'true')
      target.value = 'on'
    }
  }
})

export default button => {
  onClick.listen(button)
}
